import React from 'react';

export const BuildingSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_4309)">
          <path d="M20.6 4.1V5.1C20.6 6.6 19.8 7.9 18.5 8.7V7.2H14.4V9.3H12.3V7.2H8.2V9.3H6.2V7.2H2.1V8.7C0.8 8 0 6.7 0 5.1V4.1C0 1.8 1.8 0 4.1 0H16.5C18.7 0 20.6 1.8 20.6 4.1Z" fill={color} />
          <path d="M0 4.1001V36.0001H6.2V31.9001H14.4V36.0001H18.5C19.6 36.0001 20.6 35.1001 20.6 34.0001V4.1001H0ZM12.3 11.3001H8.2V7.2001H12.3V11.3001ZM12.3 17.5001H8.2V13.4001H12.3V17.5001ZM12.3 23.7001H8.2V19.6001H12.3V23.7001ZM6.2 17.5001H2.1V13.4001H6.2V17.5001ZM2.1 19.5001H6.2V23.6001H2.1V19.5001ZM2.1 7.2001H6.2V11.3001H2.1V7.2001ZM2.1 29.8001V25.7001H6.2V29.8001H2.1ZM8.2 25.7001H12.3V29.8001H8.2V25.7001ZM18.5 29.8001H14.4V25.7001H18.5V29.8001ZM18.5 23.7001H14.4V19.6001H18.5V23.7001ZM18.5 17.5001H14.4V13.4001H18.5V17.5001ZM18.5 11.3001H14.4V7.2001H18.5V11.3001Z" fill={color} />
          <path d="M12.3002 19.5002V23.6002H14.4002V19.5002H12.3002ZM6.2002 19.5002V23.6002H8.3002V19.5002H6.2002ZM6.2002 13.4002V17.5002H8.3002V13.4002H6.2002ZM12.3002 13.4002V17.5002H14.4002V13.4002H12.3002ZM12.3002 7.2002V11.3002H14.4002V7.2002H12.3002ZM6.2002 7.2002V11.3002H8.3002V7.2002H6.2002ZM6.2002 25.7002V29.8002H8.3002V25.7002H6.2002ZM12.3002 25.7002V29.8002H14.4002V25.7002H12.3002Z" fill="white" />
          <path d="M6.2002 6.2002V30.9002H8.3002V6.2002H6.2002ZM12.3002 6.2002V30.9002H14.4002V6.2002H12.3002Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_4309">
            <rect width="21" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5714 5.14286C20.5714 7.41497 18.7293 9.25714 16.4571 9.25714H4.11429C1.84217 9.25714 0 7.41497 0 5.14286V4.11429C0 1.84217 1.84217 0 4.11429 0H16.4571C18.7293 0 20.5714 1.84217 20.5714 4.11429V5.14286Z" fill="#C1694F" />
      <path d="M0 4.11426V36H18.5143C19.6498 36 20.5714 35.0784 20.5714 33.9428V4.11426H0Z" fill="#FFE8B6" />
      <path d="M2.05713 19.5431H18.5143V23.6573H2.05713V19.5431ZM2.05713 13.3716H18.5143V17.4859H2.05713V13.3716ZM2.05713 7.2002H18.5143V11.3145H2.05713V7.2002ZM2.05713 25.7145H18.5143V29.8288H2.05713V25.7145Z" fill="#55ACEE" />
      <path d="M6.17139 6.17139H8.22853V30.8571H6.17139V6.17139ZM12.3428 6.17139H14.4V30.8571H12.3428V6.17139Z" fill="#FFE8B6" />
      <path d="M6.17139 31.8857H14.4V36H6.17139V31.8857Z" fill="#3B88C3" />
    </svg>
  )
}